import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "isekai-rpg-container" };
const _hoisted_2 = {
    key: 0,
    class: "ambient-light"
};
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { isMobileExperience, isPortraitViewport } from '@/IsekaiRPG/shared/device';
import { GlobalActionModal, GlobalDialog, OrientationGuard, ToastContainer } from '@/IsekaiRPG/modules/ui/uiComponents';
import DecorativeCorners from '@/IsekaiRPG/shared/components/effects/DecorativeCorners.vue';
import MagicParticles from '@/IsekaiRPG/shared/components/effects/MagicParticles.vue';
import { LogService } from '@/IsekaiRPG/shared/logging/logService';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppRoot',
    setup(__props) {
        const route = useRoute();
        // 粒子效果显示状态（延迟加载优化性能）
        const showParticles = ref(false);
        // 允许显示粒子效果的路由路径（开场页使用 StartGate 内部粒子，避免重复叠加）
        const particleRoutes = ['/welcome', '/world-intro', '/story-background'];
        // 计算是否显示粒子效果：仅在特定路由且延迟加载后显示
        const showParticleEffect = computed(() => {
            return showParticles.value && particleRoutes.includes(route.path);
        });
        const isPortraitBlocked = ref(false);
        let landscapeRecoveryPending = false;
        const refreshPortraitBlockState = () => {
            isPortraitBlocked.value = route.name !== 'start-gate' && isMobileExperience() && isPortraitViewport();
        };
        const requestFullscreenSafely = () => {
            if (process.env.NODE_ENV !== 'production')
                return Promise.resolve();
            const fullscreenDocument = document;
            if (document.fullscreenElement ||
                fullscreenDocument.webkitFullscreenElement ||
                fullscreenDocument.mozFullScreenElement ||
                fullscreenDocument.msFullscreenElement) {
                return Promise.resolve();
            }
            const target = document.documentElement;
            const requestFullscreen = target.requestFullscreen ??
                target.webkitRequestFullscreen ??
                target.mozRequestFullScreen ??
                target.msRequestFullscreen;
            if (!requestFullscreen)
                return Promise.resolve();
            try {
                return Promise.resolve(requestFullscreen.call(target)).catch(error => {
                    LogService.warn('App', '全局请求全屏失败，继续保留横屏提示', error);
                });
            }
            catch (error) {
                LogService.warn('App', '全局请求全屏失败，继续保留横屏提示', error);
                return Promise.resolve();
            }
        };
        const lockLandscapeSafely = () => {
            if (landscapeRecoveryPending || typeof screen === 'undefined' || !isPortraitViewport())
                return;
            const orientation = screen.orientation;
            const lockLandscape = orientation?.lock;
            if (!orientation || !lockLandscape)
                return;
            landscapeRecoveryPending = true;
            try {
                void Promise.resolve(lockLandscape.call(orientation, 'landscape'))
                    .catch(error => {
                    LogService.warn('App', '全局锁定横屏失败，继续保留横屏提示', error);
                })
                    .finally(() => {
                    landscapeRecoveryPending = false;
                    refreshPortraitBlockState();
                });
            }
            catch (error) {
                landscapeRecoveryPending = false;
                LogService.warn('App', '全局锁定横屏失败，继续保留横屏提示', error);
            }
        };
        const handleOrientationGuardAction = () => {
            // 在支持的浏览器上，用户点击提示层时再次尝试全屏并锁定横屏。
            void requestFullscreenSafely().finally(() => {
                lockLandscapeSafely();
            });
        };
        // 延迟显示粒子效果，优化初始渲染性能
        onMounted(() => {
            // 等待1秒后显示粒子，优先保证主要内容加载
            setTimeout(() => {
                showParticles.value = true;
            }, 1000);
            refreshPortraitBlockState();
            window.addEventListener('resize', refreshPortraitBlockState);
            window.addEventListener('orientationchange', refreshPortraitBlockState);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', refreshPortraitBlockState);
            window.removeEventListener('orientationchange', refreshPortraitBlockState);
        });
        watch(() => route.name, () => {
            refreshPortraitBlockState();
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 全局通知容器 "),
                _createVNode(_unref(ToastContainer)),
                _createCommentVNode(" 全局响应式对话框 "),
                _createVNode(_unref(GlobalDialog)),
                _createCommentVNode(" 全局动作面板 (Global Action Modal) "),
                _createVNode(_unref(GlobalActionModal)),
                _createCommentVNode(" 背景装饰光效 "),
                (!isPortraitBlocked.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 魔法粒子效果（仅在欢迎页和剧情介绍页显示） "),
                (!isPortraitBlocked.value && showParticleEffect.value)
                    ? (_openBlock(), _createBlock(MagicParticles, {
                        key: 1,
                        count: 20,
                        "z-index": 5
                    }))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 装饰性边框角落 "),
                (!isPortraitBlocked.value)
                    ? (_openBlock(), _createBlock(DecorativeCorners, { key: 2 }))
                    : _createCommentVNode("v-if", true),
                (!isPortraitBlocked.value)
                    ? (_openBlock(), _createBlock(_unref(RouterView), { key: 3 }))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(OrientationGuard), {
                    visible: isPortraitBlocked.value,
                    onRetry: handleOrientationGuardAction
                }, null, 8 /* PROPS */, ["visible"])
            ]));
        };
    }
});
